import { render, staticRenderFns } from "./ModuleLessons.vue?vue&type=template&id=116cd601&scoped=true"
import script from "./ModuleLessons.vue?vue&type=script&lang=js"
export * from "./ModuleLessons.vue?vue&type=script&lang=js"
import style0 from "./ModuleLessons.vue?vue&type=style&index=0&id=116cd601&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116cd601",
  null
  
)

export default component.exports